export function hash() {
  return location.hash.substring(1).split("&").map(kv=>kv.split("=")).reduce((acc,kv)=>(acc[kv[0]]=kv[1],acc),{})
}


import { writable } from 'svelte/store';

export const hashState = writable(hash());

window.onpopstate = () => hashState.set(hash());

export const hashPut = (key,value) => {
  var map = hash()
  if (map[key] != value) {
    map[key] = value;
    location.hash="#"+Object.entries(map).filter(e=>e[0]).reduce((s,kv)=>(s+=kv[0]+"="+kv[1]+"&"),"").replace(/&$/,'')
  }
}
